@let currentTab = personExplorerService.explorer.nav.currentTab();
<kendo-tabstrip class="tabs-have-page-background" (tabSelect)="onTabChange($event)">

	<kendo-tabstrip-tab [selected]="currentTab === 0">
		@let overview = getTabInfo('Overview');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="overview.title">
				<i [class]="overview.icon"></i>
				@if(currentTab === 0){ {{overview.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-overview-part></person-overview-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 1">
		@let basicInfo = getTabInfo('BasicInfo');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="basicInfo.title">
				<i [class]="basicInfo.icon"></i>
				@if(currentTab === 1){ {{basicInfo.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-basic-info-part></person-basic-info-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 2">
		@let entrepreneurship = getTabInfo('Entrepreneurship');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="entrepreneurship.title">
				<i [class]="entrepreneurship.icon"></i>
				@if(currentTab === 2){ {{entrepreneurship.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-entrepreneurship-part></person-entrepreneurship-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 3">
		@let volunteering = getTabInfo('Volunteering');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="volunteering.title">
				<i [class]="volunteering.icon"></i>
				@if(currentTab === 3){ {{volunteering.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-volunteering-part></person-volunteering-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 4">
		@let autoEmail = getTabInfo('AutoEmail');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="autoEmail.title">
				<i [class]="autoEmail.icon"></i>
				@if(currentTab === 4){ {{autoEmail.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-emails-sent-part></person-emails-sent-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 5">
		@let notes = getTabInfo('Notes');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="notes.title">
				<i [class]="notes.icon"></i>
				@if(currentTab === 5){ {{notes.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				@if(personExplorerService.person.value(); as person) {
				<explorer-notes-part [service]="personExplorerService" [notes]="person.notes" [notesParent]="{ personId: person.personId }"></explorer-notes-part>
				}
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab [selected]="currentTab === 6">
		@let engagements = getTabInfo('Engagements');
		<ng-template kendoTabTitle>
			<span kendoTooltip [title]="engagements.title">
				<i [class]="engagements.icon"></i>
				@if(currentTab === 6){ {{engagements.title}} }
			</span>
		</ng-template>
		<ng-template kendoTabContent>
			<div class="tab-scroll-wrapper">
				<person-engagements-part></person-engagements-part>
			</div>
		</ng-template>
	</kendo-tabstrip-tab>

</kendo-tabstrip>